export default __webpack_public_path__ + "static/6C436E01-B596-4449-9271-13A09A41183F-025661dc5bbfac24968390a27ec44927.jpeg";